import angular from 'angular';
import forgotPasswordConfig from './forgot-password.config';

import forgotPassword from '../../containers/forgot-password';

const forgotPasswordModule = angular.module('meredicte.forgotPassword', [])
  .component('appForgotPassword', forgotPassword)
  .config(forgotPasswordConfig);

export default forgotPasswordModule;



// WEBPACK FOOTER //
// ./src/modules/forgot-password/forgot-password.module.js